export const stringToNumber = (str: string) => {
  if (isNaN(+str)) {
    return str;
  }
  return +str;
};
